<template>
  <div>
    <div class="datalist__title">
      <h3>{{ title }}</h3>
      <div>ID: {{ _id }}</div>
    </div>
    <div class="datalist__buttons-wrapper">
      <div class="datalist__buttons">
        <button type="button" class="save" @click="saveDataList">
          <i class="fa fa-save" aria-hidden="true"></i>
          <span>Sauvegarder la liste</span>
        </button>
        <button type="button" class="datalist__button id" @click="copyValueToClipboard(_id)">
          <i class="fa fa-copy" aria-hidden="true"></i>
          <span>Copier l'ID</span>
        </button>
        <button type="button" class="datalist__button info" v-if="!this.$route.params.list_id"
                @click="copyDataItemJSON(_id)">
          <i class="fa fa-copy" aria-hidden="true"></i>
          <span>Copier le lien JSON</span>
        </button>
        <button type="button" class="delete" @click="deleteDataList">
          <i class="fa fa-trash" aria-hidden="true"></i>
          <span>Supprimer la liste...</span>
        </button>
      </div>
      <div class="datalist__buttons">
        <button type="button" class="add" @click="addLine">
          <i class="fa fa-plus" aria-hidden="true"></i>
          <span>Ajouter une ligne</span>
        </button>
        <button type="button"
                class="delete"
                @click="deleteDataListsField(selectedItemIds)"
                :disabled="!selectedItemIds.length"
        >
          <i class="fa fa-trash-o" aria-hidden="true"></i>
          <span>Supprimer la sélection...</span>
        </button>
      </div>
    </div>

    <div class="table__wrapper">
      <table class="datalist__table">
        <tr class="table__head">
          <th rowspan="2" class="table__checkbox">
            <input type="checkbox"
                   @change="toggleCheckedItems"
                   :checked="selectedItemIds.length === dataLists.length && dataLists.length > 0"
            >
          </th>
          <th
            class="table__field"
            v-for="field of Object.keys(dataListsFields)"
            :key="field"
            :rowspan="getRowSpan(field)"
            :colspan="getColSpan(field)"
          >
            {{ field }}
            <button class="table__btn btn-add"
                    v-if="isFieldObject(field)"
                    type="button"
                    @click="addDatalistSubfield(field)">+
            </button>
          </th>
        </tr>
        <tr class="table__head">
          <template
            v-if="isFieldObject(field)"
            v-for="field of Object.keys(dataListsFields)"
          >
            <th
              class="table__subfield"
              v-for="subField of Object.keys(dataListsFields[field])"
              :key="field + '.' + subField"
            >
              {{ subField }}
              <button
                  class="table__btn btn-delete"
                  type="button"
                  @click="deleteDatalistSubfield(field,subField)">-
              </button>
            </th>
          </template>
        </tr>
        <tr
          class="table__body"
          v-for="(data, index) of dataLists"
          :key="data._id || index"
        >
          <td class="table__checkbox">
            <input type="checkbox"
                   @change="checkItem(index, $event)"
                   :checked="selectedItemIds.includes(index)">
          </td>
          <template
            v-for="field of Object.keys(data).filter(f => !f.startsWith('_'))"
          >
            <td
              v-if="typeof data[field] !== 'object'"
              :key="field"
            >
              <input type="text" :value="data[field]" v-if="!isFieldObject(field)"
                     @change="saveElementValue($event,index,field)">
            </td>
            <td
              v-else
              v-for="subField of Object.keys(data[field])"
              :key="field + '.' + subField"
            >
              <input type="text" :value="data[field][subField]"
                     v-if="typeof dataListsFields[field][subField] !== 'object'"
                     @change="saveElementValue($event,index,field,subField)">
            </td>
          </template>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "DataListItem",
  props: {
    _id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true
    },
    dataLists: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      dataListsFields: this.dataLists[0] ? this.rewriteDataListsFields() : {
        label: '',
        value: '',
        metadata: {},
      },
      selectedItemIds: [],
    }
  },
  methods: {
    async copyDataItemJSON(id) {
      await this.copyValueToClipboard(`${this.$axios.defaults.baseURL}/api/v2/data-list/json/${id}`)
    },
    async copyValueToClipboard(value) {
      try {
        await navigator.clipboard.writeText(value);
        await this.$swal({
          title: "Copié!",
          type: "success",
          showConfirmButton: false,
          timer: 1000,
        });
      } catch(e) {
        await this.$swal({
        title: "Erreur!",
        type: "error",
        showConfirmButton: false,
        timer: 1000,
      });
      }
    },
    getRowSpan(field) {
      return !this.isFieldObject(field) ? 2 : (this.isFieldObject(field) && !Object.keys(this.dataListsFields[field]).length) ? 2+this.dataLists.length : null
    },
    getColSpan(field) {
      return (this.isFieldObject(field) && Object.keys(this.dataListsFields[field]).length)  ? Object.keys(this.dataListsFields[field]).length : null
    },
    addLine() {
      this.dataLists.push(JSON.parse(JSON.stringify(this.dataListsFields)))
    },
    isFieldObject(field) {
      return typeof this.dataListsFields[field] === 'object'
    },
    checkItem(index, event) {
      if(event.target.checked){
        this.selectedItemIds.push(index)
      }else {
        this.selectedItemIds = this.selectedItemIds.filter((el) => el !== index)
      }
    },
    toggleCheckedItems() {
      if (this.selectedItemIds.length === this.dataLists.length) {
        this.selectedItemIds = []
      } else {
        this.selectedItemIds = this.dataLists.map((el, index) => index)
      }
    },
    async deleteDataListsField(indexes) {
      let confirmation = await this.$swal({
        title: "Supprimer des éléments",
        text: `Supprimer ${indexes.length} ${
            indexes.length === 1 ? "élément" : "éléments"
        }?`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, supprimer",
      });
      if (confirmation.value) {
        let elementsForSave = this.dataLists.filter((el, i) => !indexes.includes(i))
        await this.deleteDataListItems(elementsForSave)

      }
    },
    rewriteDataListsFields() {
      let clone = {}
      for (const key of Object.keys(this.dataLists[0])) {
        if (key.startsWith('_')) continue
        if (typeof this.dataLists[0][key] === 'object') {
          clone[key] = {}
          Object.keys(this.dataLists[0][key]).forEach(key2 => {
            Object.assign(clone[key], {[key2]: ''})
          })
        } else {
          clone[key] = ''
        }
      }
      // this.dataListsFields = JSON.parse(JSON.stringify(clone))
      return JSON.parse(JSON.stringify(clone))
    },
    async addDatalistSubfield(field) {
      await this.$swal({
        title: "Ajouter un sous-champ",
        input: "text",
        inputPlaceholder: "Nom du sous-champ",
        showCancelButton: true,
        inputValidator: (value) => {
          return !value && "Vous devez saisir un nom de sous-champ";
        },
      }).then((result) => {
        if (result.value) {
          Vue.set(this.dataListsFields[field], result.value, '');
          this.dataLists.forEach(datalist => Vue.set(datalist[field], result.value, ''));
        }
      });
    },
    async deleteDatalistSubfield(field, subfield) {
      await this.$swal({
        title: "Supprimer un sous-champ",
        text: "Êtes-vous sûr de vouloir supprimer ce sous-champ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
      }).then((result) => {
        if (result.value) {
          Vue.delete(this.dataListsFields[field], subfield);
          this.dataLists.forEach(datalist => Vue.delete(datalist[field], subfield));
        }
      });
    },
    saveElementValue(event, index, field, subfield) {
      if (!subfield) {
        this.dataLists[index][field] = event.target.value;
      } else {
        this.dataLists[index][field][subfield] = event.target.value;
      }
    },
    async saveDataList() {
      let result = await this.$axios.put(
        `/api/v2/data-list/update/${this.$route.params._id}`,
        { values: this.dataLists, _id: this._id },
      )
      if (result.status === 200) {
        await this.$swal({
          position: "center",
          type: "success",
          title: "Les données ont été enregistrées",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    async deleteDataList() {
      let confirm = await this.$swal({
        title: "Supprimer la liste de données",
        html: `Pour supprimer la liste, saisissez le texte suivant : <b>${this.title}.</b>`,
        input: "text",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
        preConfirm: (value) => {
          return value === this.title;
        }
      })
      if (confirm.value){
        let result = await this.$axios.delete("/api/v2/data-list/delete/" + this.$route.params._id, {data: {_id: this._id}})
        if (result.status === 200) {
          await this.getDataList()
          await this.$swal({
            position: "center",
            type: "success",
            title: "La liste de données a été supprimée",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    },
    async deleteDataListItems (newValues) {
      let result = await this.$axios.put( "/api/v2/data-list/update/" + this.$route.params._id,{values: newValues, _id: this._id})
      if (result.status === 200) {
        this.selectedItemIds = []
        this.getDataList()
        await this.$swal({
          position: "center",
          type: "success",
          title: "Les données ont bien été supprimées",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    getDataList() {
      this.$emit('get-data-list')
    }
  }
}
</script>

<style scoped lang="scss">
.datalist {
  border: 2px solid #3f3f3f;
  border-radius: 5px;
  background: linear-gradient(110deg, #f8faff, #e0ecfc);
}

.datalist__title,
.datalist__buttons {
  display: flex;
  gap: 10px;
}

.datalist__title {
  align-items: center;

  h3 {
    flex: 1;
  }

  div {
    font-family: monospace;
  }
}

.datalist__buttons-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  justify-content: space-between;
}

.datalist__buttons-wrapper button {
  padding: 5px 15px;
  background: transparent;
  border: 2px solid #6462f2;
  border-radius: 5px;
  color: #6462f2;
  font-weight: bold;
  transition: all 0.3s ease;

  span {
    margin-left: 4px;
  }

  &.add {
    border-color: green;
    color: green;
  }

  &.delete {
    border-color: red;
    color: red;
  }

  &:disabled {
    background: #ccc;
    filter: saturate(0);
    opacity: 0.5;
    pointer-events: none;
  }
}

.datalist__table {
  border: 1px solid #888;
  width: 100%;
  border-collapse: collapse;
}

.table__btn {
  padding: 0 4px;
  color: white;
  border: none;
  outline: none;
  &.btn-delete {
    background: tomato;
  }
  &.btn-add {
    background: green;
  }
}

.table__wrapper {
  width: 100%;
  margin: 0 auto;
  overflow-x: scroll;
  padding: 1rem 0;
}

.table__head th {
  background: #d9d9d9;
}

.table__body:nth-child(even) {
  background: linear-gradient(110deg, #eeeeef, #e9eaec);
}

.table__body:nth-child(odd) {
  background: linear-gradient(110deg, #f8faff, #e0ecfc);
}

.table__checkbox {
  padding: 10px;

  input {
    display: block;
    margin: 0 auto;
  }
}

.table__field {
  min-width: 150px;
}

.table__subfield {
  min-width: 200px;
}

.table__wrapper input[type="text"] {
  box-sizing: border-box;
  width: 100%;
  display: block;
  margin: 0;
  border-radius: 0;
  border: 0;
  padding: 3px 10px;
}

th, td, tr {
  border: 1px solid #888;
}

td {
  padding: 0;
}

@media screen and (max-width: 901px) {
  .datalist__buttons {
    font-size: 0.8rem;
    button {
      padding: 5px 10px
    }
  }
}

@media screen and (max-width: 837px) {
  .datalist__buttons {
    span {
      display: none;
    }
  }
}

</style>